import { Outlet , useNavigate} from "react-router-dom"
import Header from "../Header/Header"
import { useContext, useEffect, useState , } from "react";
import { Context } from "../../Context/Context";
import { fetchAuthSession } from '@aws-amplify/auth';
import { TOKEN, ADMIN, PROFESSIONAL, CLIENT, FIRM, checkIfLoggedInApi } from "../../Constants";
import axios from "axios";
import LoadingGauge from "Components/Icons/LoadingGauge";

const RootComp = ({rootComp, roleType}) => {
    const navigate = useNavigate();
    const [isResponseReceived, setIsResponseReceived] = useState(false);
    const {updateLoggedinData, setUserDetails, setShowLoading, setNotificationCount, setAwaitCount} = useContext(Context);
    const getUserDetails = async(accessToken) => 
    {
        if(accessToken)
        {
            try {
                setShowLoading(true);
                const data = await axios.get(checkIfLoggedInApi, {headers: {'Authorization': accessToken}});
                if({data})
                {
                    setShowLoading(false);
                    //commenting MFA code - 15-10-2024
                    // if(data?.data?.message === "MFARequired")
                    // {
                    //     console.log("data", data.data);
                    //     navigate("/mfaAuth");
                    // }
                    // else
                    // {
                        setShowLoading(false);
                        setUserDetails(data?.data);
                        setNotificationCount(data?.data?.notifications);
                        setIsResponseReceived(true);
                        builder(data?.data);
                    // }
                }
                else
                {
                    setShowLoading(false);
                    setIsResponseReceived(true);
                    // navigate("/signin");
                }
                
            }  
            catch (error)
            {
                setIsResponseReceived(true);
                console.log("session expired. login again")
                // navigate("/signin");
            }
        }
    }

    useEffect(() => 
    {
        try {

            fetchAuthSession().then((session) => {
                const accessToken = session.tokens.accessToken.toString();
                console.log("fetched session", session);
                getUserDetails(accessToken);
            }
            ).catch((error) => {
                console.log("error", error)
                setIsResponseReceived(true);
                if(!rootComp)
                {
                    navigate("/signin");
                }
            }
            );
        } catch (error) {
            console.log("error", error)
            setIsResponseReceived(true);
            if(!rootComp)
            {
                navigate("/signin");
            }
        }
    },[updateLoggedinData]);

    // Already signed in and opened /signin, /signup or /resetPassword:
    // send them to their own home instead of showing the form again.
    const builder = (data) => {
        if(!data?.role && data?.role !== ADMIN) return;
        if(data?.role === PROFESSIONAL || data?.role === FIRM)
        {
            const ready = data?.isUserAssistant ? !!data?.profilePic : !!data?.verified;
            if(ready)
            {
                navigate("/attorney/casesFeed/availableCases", {replace: true});
            }
            else if(data?.isUserAssistant || (data?.role === PROFESSIONAL && data?.legalType === null) || (data?.role === FIRM && !data?.pendingReview))
            {
                // never filled in the profile
                navigate("/attorney/profileCompletion", {replace: true});
            }
            else
            {
                // profile sent, waiting for review: law firms go to the case dashboard
                // (its "under review" popup shows the cases clients saved for them),
                // attorneys to the profile page which shows the status
                navigate(data?.role === FIRM ? "/attorney/casesFeed/availableCases" : "/attorney/profile", {replace: true});
            }
        }
        else if(data?.role === ADMIN)
        {
            navigate(data.isAdminAssistant ? "/admin/approve" : "/admin/outreach", {replace: true});
        }
        else if(data?.role === CLIENT)
        {
            navigate("/client/cases", {replace: true});
        }
    }
    return (
        <>
        {isResponseReceived ? <Outlet/> :
        <LoadingGauge/>
        }
        {console.log("Root component loaded")}
        </>
    
    )
}

export default RootComp
